import { PALETTES, PALETTE_CSS } from "@/lib/palettes";

// Use the same saved palettes as the dashboard. Classic Light keeps dark
// syntax colors under its inversion filter; real light palettes use Shiki's
// light colors. Derive the selectors so future palettes work automatically.
export const CONTENT_PALETTE_CSS =
  PALETTE_CSS +
  PALETTES.filter((palette) => palette.mode === "light" && !palette.inverted)
    .map(
      (palette) =>
        `html[data-theme="light"][data-palette-light="${palette.id}"] .content-site :is(.shiki code,code.shiki) span{color:var(--shiki-light);font-style:var(--shiki-light-font-style)}`,
    )
    .join("\n");
